import { AuthLayoutWrap } from './styles';

import type { AccountAccessLayoutInterface } from './interface';

const Auth = ({ children }: AccountAccessLayoutInterface) => (
    <AuthLayoutWrap>{children}</AuthLayoutWrap>
);

export default Auth;
